export default __webpack_public_path__ + "static/media/img7.1240cd0a.jpg";